import { globalConstants, centersConstants } from "../../constants";

const initialState = {
  approvedCentersData: { page: {}, pageData: [] },
  pendingCentersData: null,
  centerProfileData: null,
  centerLogo: null,
  centerSpotData: null,
  centerList: null,
  isCenterRePaymentModal: false,
};

const {
  PENDING_CENTERS_LIST,
  CENTER_DATA_BY_ID,
  APPROVED_CENTERS_LIST,
  GET_CENTER_LOGO,
  CENTER_SPOT_DATA_BY_ID,
  CENTERS_LIST,
  IS_CENTER_REPAYMENT_MODAL,
} = centersConstants;

const centersReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVED_CENTERS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        approvedCentersData: action.data,
      };
    case PENDING_CENTERS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        pendingCentersData: action.data,
      };
    case CENTERS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        centerList: action.data,
      };
    case CENTER_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        centerProfileData: action.data,
      };
    case GET_CENTER_LOGO + globalConstants.SUCCESS:
      return {
        ...state,
        centerLogo: action.data,
      };
    case CENTER_SPOT_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        centerSpotData: action.data,
      };
    case IS_CENTER_REPAYMENT_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isCenterRePaymentModal: action.data,
      };
    default:
      return state;
  }
};

export default centersReducer;
